// Copyright: IQGeo Limited 2010-2022
// base myWorld code to be used in pages such as config and home
// also defines what goes into myWorld-base.min.js
import myw from 'myWorld/base/core';
import 'myWorld/base/errors';
import 'myWorld/base/util';
import 'myWorld/base/config';
import 'myWorld/base/localisation';
import 'myWorld/base/view';
import 'myWorld/base/control';
import 'myWorld/base/plugin';
import 'myWorld/base/pluginButton';
import 'myWorld/base/viewManager';
import 'myWorld/base/unitScale';
import 'myWorld/base/semaphore';
import 'myWorld/base/usageMonitor';
import { latLng, LatLng } from 'myWorld/base/latLng.js';
import { latLngBounds, LatLngBounds } from 'myWorld/base/latLngBounds.js';
import DBPredicate from 'myWorld/base/dbPredicate';
import FilterParser from 'myWorld/base/filterParser';
import Predicate from 'myWorld/base/predicate.js';
import * as Browser from 'myWorld/base/browser';
export { Browser };
myw.Browser = Browser;

import * as styleUtils from 'myWorld/styles/styleUtils';
myw.styleUtils = styleUtils;

myw.latLng = latLng;
myw.LatLng = LatLng;
myw.latLngBounds = latLngBounds;
myw.LatLngBounds = LatLngBounds;

myw.DBPredicate = DBPredicate;
myw.FilterParser = FilterParser;
myw.Predicate = Predicate;

export default myw;
